import { useRef } from 'react'
import { useParams } from 'react-router-dom'
import { RouteParams } from '@sketch/modules-common'

/**
 * Returns the very first artboard id used by the user to enter the prototype.
 *
 * Note: Keep in mind that if this hook gets remounted the artboardId value
 * it exposes will get reset to the current value from the url.
 *
 * @TODO: Consider pulling the value exposed by this hook into the
 * PrototypeViewContext - this will reduce the possibility of a re-mount
 * changing it.
 */
export function useInitialPrototypeArtboardId() {
  const { permanentArtboardShortId } = useParams<RouteParams<'PROTOTYPE'>>()
  const { artboardUUID } = useParams<RouteParams<'PROTOTYPE_VIEW'>>()

  // Save the very first artboard id the user has landed on in a ref so it nevers changes
  // even after navigating to new prototype artboards

  // @TODO Remove conditional when `prototype-manifest-file` FF is cleaned,
  // at that point PROTOTYPE view will no longer be used to display prototypes
  // and permanentArtboardShortId will never be defined
  const firstArtboardId = useRef(permanentArtboardShortId || artboardUUID)

  return firstArtboardId.current
}
